import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41e05eb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { ref, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-page-number-10',
  props: {
    isDetail: { type: Boolean, default: false },
    pageNo: { default: '01' }
  },
  setup(__props: any) {

const props = __props;

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 74 49.264">
    <g id="yema10" transform="translate(-66 -684)">
      <text id="_01" data-name="01" transform="translate(86 721)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
      <rect id="矩形_2891" data-name="矩形 2891" width="49.264" height="3" transform="translate(77 684) rotate(90)" fill="var(--theme-color-1)"/>
      <rect id="矩形_2895" data-name="矩形 2895" width="49.264" height="3" transform="translate(132 684) rotate(90)" fill="var(--theme-color-1)"/>
      <rect id="矩形_2893" data-name="矩形 2893" width="34.264" height="3" transform="translate(69 692) rotate(90)" fill="var(--theme-color-1)"/>
      <rect id="矩形_2894" data-name="矩形 2894" width="34.264" height="3" transform="translate(140 692) rotate(90)" fill="var(--theme-color-1)"/>
    </g>
  </svg>
`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["svg-block", !_ctx.isDetail && 'isDetail']),
    innerHTML: svg.value
  }, null, 10, _hoisted_1))
}
}

})